import React, { useEffect, useState } from "react"

import { FormProvider, useForm } from "react-hook-form"

import { ButtonElement } from "@front-shared/elements/button.element"
import { useStateCallback } from "@front-shared/hooks/useStateCallback.hook"

import { NetworkStatusHelper } from "../../../helpers/networkStatus.helper"
import type { INetworkStatusRulesFilters } from "../../../types/networkStatus.types"
import { NetworkStatusRulesFiltersFormComponent } from "./networkStatusRulesFiltersForm.component"

export const NetworkStatusRulesFiltersComponent: React.FunctionComponent<
    INetworkStatusRulesFiltersComponentProps
> = props => {
    const formMethods = useForm<INetworkStatusRulesFilters>()

    const { handleSubmit, reset } = formMethods

    const [filtersFormKey, setFiltersFormKey] = useState<number>(
        new Date().getTime(),
    )

    const [existingFilters, setExistingFilters] =
        useStateCallback<INetworkStatusRulesFilters>(props.existingFilters)

    useEffect(() => {
        reset(existingFilters)
    }, [JSON.stringify(existingFilters), filtersFormKey])

    const onResetFilters = () => {
        const defaultFilters = NetworkStatusHelper.getDefaultRulesFilters()

        reset(defaultFilters)

        setExistingFilters(defaultFilters, () => {
            setFiltersFormKey(new Date().getTime())
        })
    }

    const onSubmitForm = (data: INetworkStatusRulesFilters) => {
        const sanitized = NetworkStatusHelper.sanitizeRulesFilters(data)

        props.onFiltersSubmitted(sanitized)
    }

    return (
        <div className={props.className}>
            <div
                key={filtersFormKey}
                className="relative px-[24px] pb-[24px] flex-1"
            >
                <FormProvider {...formMethods}>
                    <form
                        className="h-full"
                        onSubmit={handleSubmit(onSubmitForm)}
                    >
                        <NetworkStatusRulesFiltersFormComponent
                            className="h-full overflow-y-auto pb-[100px]"
                            existingFilters={existingFilters}
                        />

                        <div
                            className="
                                absolute bottom-0 z-100 left-0 w-full flex items-center p-[24px]
                                bg-brand-offWhite border-t border-solid border-brand-warmLight
                            "
                        >
                            <ButtonElement
                                buttonClassName="min-w-[100px]"
                                label="Reset"
                                onClick={onResetFilters}
                                htmlType="button"
                                type="default"
                            />

                            <div className="flex-1" />

                            <ButtonElement
                                className="ml-[16px]"
                                buttonClassName="min-w-[100px]"
                                label="Filter"
                                htmlType="submit"
                                type="primary"
                            />
                        </div>
                    </form>
                </FormProvider>
            </div>
        </div>
    )
}

interface INetworkStatusRulesFiltersComponentProps {
    className?: string
    existingFilters: INetworkStatusRulesFilters
    onFiltersSubmitted: (data: INetworkStatusRulesFilters) => void
}
